import { Grid, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const Heading = () => {
	const { t } = useTranslation();
	const theme = useTheme();

	return (
		<>
			<Grid
				container
				direction="column"
				sx={{ pt: { xs: '30px', md: '60px' }, alignItems: { xs: 'center', md: 'flex-start' }, textAlign: { xs: 'center', md: 'start' } }}>
				<Grid item>
					<Typography variant="h4" color={theme.surfaces.contrastText} sx={{ fontWeight: '600' }}>
						{t('TRACK_TRANSFER_FOR_BUSINESS_INDIVIDUALS')}
					</Typography>
				</Grid>
				<Grid item>
					<Typography variant="h2">{t('TRACK_YOUR_TRANSFER')}</Typography>
				</Grid>
				<Grid item>
					<Typography variant="h4">{t('TRACKING_INSTRUCTIONS')}</Typography>
				</Grid>
			</Grid>
		</>
	);
};
